import { ToastContainer, toast } from 'react-toastify'

export const errorToast = msg =>
  toast.error(msg, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  })
